import { Edit, SelectInput, SimpleForm, TextInput, useNotify } from 'react-admin';
import { useEffect, useState } from 'react';

import { apiFetch } from '../../api/client';
import { formatError } from '../../utils/formatApiError';
import { OwnerAccessPanel } from './OwnerAccessPanel';

export function BusinessEdit() {
  const notify = useNotify();
  const [categories, setCategories] = useState<{ id: number; name: string }[]>([]);

  useEffect(() => {
    void apiFetch<{ data: { id: number; name: string }[] }>('/admin/geo/categories').then((res) =>
      setCategories(res.data),
    );
  }, []);

  return (
    <Edit
      aside={<OwnerAccessPanel />}
      mutationOptions={{
        onError: (error) => {
          notify(formatError(error), { type: 'error', multiLine: true });
        },
      }}
    >
      <SimpleForm>
        <TextInput source="name" fullWidth validate={(value) => (!value ? 'Name is required' : undefined)} />
        <TextInput source="tagline" fullWidth />
        <TextInput source="description" fullWidth multiline rows={4} />
        <SelectInput
          source="category_id"
          label="Category"
          choices={categories}
          optionText="name"
          optionValue="id"
        />
        <TextInput source="address_line" fullWidth />
        <TextInput source="pincode" />
        <TextInput source="phone" />
        <TextInput source="whatsapp" />
        <TextInput source="email" />
        <TextInput source="website_url" fullWidth />
        <SelectInput
          source="status"
          choices={[
            { id: 'draft', name: 'Draft' },
            { id: 'pending_review', name: 'Pending Review' },
            { id: 'published', name: 'Published' },
            { id: 'suspended', name: 'Suspended' },
            { id: 'archived', name: 'Archived' },
          ]}
        />
      </SimpleForm>
    </Edit>
  );
}
